
      import {selectElement} from '@folkjs/labs/interactions/dom-selection'
      import {selectElements} from '@folkjs/labs/interactions/dom-multi-selection'
      import {clickToCreateElement, dragToCreateShape} from '@folkjs/labs/interactions/create-element'
      import '@folkjs/labs/standalone/folk-shape-attribute';

      function filter(el) {
        const value = window.selectorInput.value;

        // ignore other tools
        if (el.closest('#instruments')) return null;

        return value === '' ? el : el.closest(value)
      }
     
      window.select = async () => {
        const cancel = new AbortController();
        const el = await selectElement(cancel.signal, document, filter);
        console.log(el)
      }

      let selectingManyComplete = null;

      window.selectMany = async () => {
        if (selectingManyComplete) {
          selectingManyComplete.abort();
        } else {
          selectingManyComplete = new AbortController();
          const cancel = new AbortController();
          const elements = await selectElements(selectingManyComplete.signal, cancel.signal, filter);
          selectingManyComplete = null;
          console.log(elements)
        }
      }

      window.clickToCreate = async () => {
        const cancel = new AbortController();

        const el = await clickToCreateElement(document.body, cancel.signal, ({x, y}) => {
          const div = document.createElement('div');
          div.setAttribute('folk-shape', `x: ${x - 25}; y: ${y - 25}; width: 50; height: 50`);
          return div;
        })

        setTimeout(() => el.focus());

        console.log(el)
      }

      window.dragToCreate = async () => {
        const cancel = new AbortController();

        const el = await dragToCreateShape(
          document.body, 
          cancel.signal, 
          () => document.createElement('div'),
        )

        el.focus();

        console.log(el)
      }
    